import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiMail, FiPhone, FiDollarSign, FiTarget } = FiIcons;

const RegistrationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    currentIncome: '',
    incomeGoal: '',
    interest: 'BOTH'
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate API call
    setTimeout(() => {
      navigate('/thank-you');
    }, 800);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="space-y-1">
        <label className="text-sm text-slate-400 ml-1">Full Name</label>
        <div className="relative">
          <SafeIcon icon={FiUser} className="absolute left-4 top-3.5 text-slate-500" />
          <input 
            type="text" 
            name="name"
            required
            className="w-full bg-slate-900/50 border border-white/10 rounded-xl py-3 pl-11 pr-4 text-white focus:outline-none focus:border-amber-500/50 transition-colors"
            placeholder="John Doe"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        <div className="space-y-1">
          <label className="text-sm text-slate-400 ml-1">Email Address</label>
          <div className="relative">
            <SafeIcon icon={FiMail} className="absolute left-4 top-3.5 text-slate-500" />
            <input 
              type="email" 
              name="email"
              required
              className="w-full bg-slate-900/50 border border-white/10 rounded-xl py-3 pl-11 pr-4 text-white focus:outline-none focus:border-amber-500/50 transition-colors"
              placeholder="john@example.com"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="space-y-1">
          <label className="text-sm text-slate-400 ml-1">Phone Number</label>
          <div className="relative">
            <SafeIcon icon={FiPhone} className="absolute left-4 top-3.5 text-slate-500" />
            <input 
              type="tel" 
              name="phone"
              required
              className="w-full bg-slate-900/50 border border-white/10 rounded-xl py-3 pl-11 pr-4 text-white focus:outline-none focus:border-amber-500/50 transition-colors"
              placeholder="+91 98765 43210"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
         <div className="space-y-1">
          <label className="text-sm text-slate-400 ml-1">Current Income Range</label>
          <div className="relative">
            <SafeIcon icon={FiDollarSign} className="absolute left-4 top-3.5 text-slate-500" />
            <select 
              name="currentIncome"
              className="w-full bg-slate-900/50 border border-white/10 rounded-xl py-3 pl-11 pr-4 text-white focus:outline-none focus:border-amber-500/50 transition-colors appearance-none"
              value={formData.currentIncome}
              onChange={handleChange}
            >
              <option value="" disabled>Select Range</option>
              <option value="0-50k">₹0 - ₹50k / month</option>
              <option value="50k-1L">₹50k - ₹1L / month</option>
              <option value="1L-3L">₹1L - ₹3L / month</option>
              <option value="3L+">₹3L+ / month</option>
            </select>
          </div>
        </div>
        <div className="space-y-1">
          <label className="text-sm text-slate-400 ml-1">Income Goal</label>
          <div className="relative">
             <SafeIcon icon={FiTarget} className="absolute left-4 top-3.5 text-slate-500" />
             <input 
              type="text" 
              name="incomeGoal"
              className="w-full bg-slate-900/50 border border-white/10 rounded-xl py-3 pl-11 pr-4 text-white focus:outline-none focus:border-amber-500/50 transition-colors"
              placeholder="e.g. ₹5L/month"
              value={formData.incomeGoal}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div className="space-y-1">
        <label className="text-sm text-slate-400 ml-1">Area of Interest</label>
        <div className="grid grid-cols-3 gap-3">
          {['HEAL', 'CASH', 'BOTH'].map((opt) => (
            <button
              key={opt}
              type="button"
              onClick={() => setFormData({ ...formData, interest: opt })}
              className={`py-3 rounded-xl border transition-all ${
                formData.interest === opt 
                  ? 'bg-amber-500/20 border-amber-500 text-amber-400 font-bold' 
                  : 'bg-slate-900/50 border-white/10 text-slate-400 hover:border-white/30'
              }`}
            >
              {opt}
            </button>
          ))}
        </div>
      </div>

      <button 
        type="submit"
        className="w-full mt-4 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-bold text-lg py-4 rounded-xl hover:shadow-[0_0_20px_rgba(245,158,11,0.4)] transition-all transform hover:scale-[1.02]"
      >
        💎 Reserve My Diamond Seat Now
      </button>
    </form>
  );
};

export default RegistrationForm;